module.exports = __webpack_public_path__ + "img/pic4.0c93339e.png";